import React, { useEffect, useState } from 'react';
import { simulateStrategy } from '../../../services/StrategiesService';
import { processError } from '../../../services/ServiceUtils';

/**
 * Modal "Simular comportamento": roda a bateria de situações de mercado nas automações reais
 * da estratégia (sem corretora, sem mexer no banco) e mostra o que cada automação faria + as
 * anomalias detectadas. props: { data: { id } } — busca ao mudar o id.
 */
export default function SimulateStrategyModal(props) {
    const [report, setReport] = useState(null);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const id = props.data && props.data.id;

    useEffect(() => {
        if (!id) return;
        setReport(null);
        setError('');
        setLoading(true);
        simulateStrategy(id)
            .then(r => setReport(r))
            .catch(err => setError(getErr(err)))
            .finally(() => setLoading(false));
    }, [id]);

    function getErr(err) {
        const msg = processError(err);
        return typeof msg === 'string' ? msg : (msg && msg.error) || 'Falha ao simular.';
    }

    function fmt(f) {
        return `${f.side === 'BUY' ? 'Comprou' : 'Vendeu'} ${f.qty}`;
    }

    return (
        <div className="modal fade" id="modalSimulateStrategy" tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Simular comportamento</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Fechar"></button>
                    </div>
                    <div className="modal-body">
                        <p className="text-muted small">
                            Roda a estratégia contra situações de mercado simuladas (sem corretora e sem
                            alterar nada) e mostra o que cada automação faria. Ótimo pra conferir antes de ligar.
                        </p>

                        {loading && <div className="text-center py-4"><div className="spinner-border" role="status" /></div>}
                        {error && <div className="alert alert-danger">{error}</div>}

                        {report && (
                            <>
                                <div className="mb-2 small text-muted">
                                    Símbolo testado: <strong>{report.symbol}</strong>
                                    {report.automationsLoaded && report.automationsLoaded.length > 0 &&
                                        <> · {report.automationsLoaded.length} automação(ões)</>}
                                </div>
                                <table className="table table-sm align-middle">
                                    <thead>
                                        <tr><th>Situação de mercado</th><th>O que a estratégia faria</th></tr>
                                    </thead>
                                    <tbody>
                                        {report.situations.map((s, i) => (
                                            <tr key={i}>
                                                <td>{s.label}</td>
                                                <td>
                                                    {s.error
                                                        ? <span className="text-danger">erro: {s.error}</span>
                                                        : (s.fired && s.fired.length
                                                            ? s.fired.map((f, j) => (
                                                                <span key={j} className="badge bg-primary me-1">{fmt(f)}</span>))
                                                            : <span className="text-muted">não operou</span>)}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                {report.anomalies && report.anomalies.length > 0 ? (
                                    <div className="alert alert-warning mb-0">
                                        <strong>Anomalias detectadas:</strong>
                                        <ul className="mb-0">{report.anomalies.map((a, i) => <li key={i}>{a}</li>)}</ul>
                                    </div>
                                ) : (
                                    <div className="alert alert-success mb-0">Nenhuma anomalia detectada (sem churn, carteira sã).</div>
                                )}
                            </>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    );
}
